exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".d-dropdown .d-select-list {\n  overflow: auto; }\n\n.d-dropdown.expanded .d-select-list {\n  max-height: 300px;\n  -webkit-animation: 500ms cubic-bezier(0.215, 0.61, 0.355, 1) 0ms dropdown-expand;\n          animation: 500ms cubic-bezier(0.215, 0.61, 0.355, 1) 0ms dropdown-expand; }\n\n@-webkit-keyframes dropdown-expand {\n  from {\n    max-height: 0; }\n  to {\n    max-height: 300px; } }\n\n@keyframes dropdown-expand {\n  from {\n    max-height: 0; }\n  to {\n    max-height: 300px; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib?{"config":{"path":"postcss.config.js"}}!./node_modules/sass-loader/lib/loader.js!./Src/Shared/Form/Dropdown/Animations.scss
// module id = 371
// module chunks = 3 6